import { SpriteSheet, Actor, vec, CollisionType, Engine } from "excalibur";
import { Resources } from "./resources";
import { Constants } from "./const";

const junkFoods = ["hamburger", "fries"] as const;

export function randomJunkFoodType(): JunkFoodType {
  const index = Math.floor(Math.random() * junkFoods.length);
  return junkFoods[index];
}

type JunkFoodType = (typeof junkFoods)[number];

function getSpriteForFastFoodType(junkFoodType: JunkFoodType) {
  const sheet = SpriteSheet.fromImageSource({
    image: Resources.PlantSheet1,
    grid: {
      rows: 14,
      columns: 14,
      spriteWidth: 36,
      spriteHeight: 36,
    },
  });
  switch (junkFoodType) {
    case "hamburger":
      return sheet.getSprite(8, 1);
    case "fries":
      return sheet.getSprite(4, 6);
  }
}

export class JunkFood extends Actor {
  Type: JunkFoodType;

  constructor(t: JunkFoodType) {
    super({
      // Giving your actor a name is optional, but helps in debugging using the dev tools or debug mode
      // https://github.com/excaliburjs/excalibur-extension/
      // Chrome: https://chromewebstore.google.com/detail/excalibur-dev-tools/dinddaeielhddflijbbcmpefamfffekc
      // Firefox: https://addons.mozilla.org/en-US/firefox/addon/excalibur-dev-tools/
      name: t,
      pos: vec(Constants.GameWidth, Constants.GameHeight - 100),
      width: Constants.FoodSize,
      height: Constants.FoodSize,
      vel: vec(Constants.FoodSpeed, 0),
      // anchor: vec(0, 0), // Actors default center colliders and graphics with anchor (0.5, 0.5)
      collisionType: CollisionType.Passive, // Collision Type Active means this participates in collisions read more https://excaliburjs.com/docs/collisiontypes
    });
    this.Type = t;
  }

  override onInitialize(engine: Engine): void {
    super.onInitialize(engine);
    this.graphics.add(getSpriteForFastFoodType(this.Type));
    this.on("exitviewport", () => this.kill());
  }
}
